export var observableWrapper = function (defaultState, opts) {
    var _a, _b;
    return (_b = (_a = opts.observable) === null || _a === void 0 ? void 0 : _a.call(opts, defaultState)) !== null && _b !== void 0 ? _b : defaultState;
};
//# sourceMappingURL=observable.js.map